import { ConnectionShare } from "./useFormatConnectionShares";
export function reduceSharesToAdd(toAdd: ConnectionShare[]) {
  return toAdd?.reduce(
    (accumulator: number[][], { id, shareType }) => {
      if (shareType === "member") {
        accumulator[0].push(Number(id));
      }
      if (shareType === "group") {
        accumulator[1].push(Number(id));
      }
      if (shareType === "all") {
        accumulator[2].push(Number(id));
      }
      return accumulator;
    },
    [[], [], []],
  );
}
